
import { User } from '@/types/user';
import { supabase } from "@/integrations/supabase/client";
import { createUserProfile } from '@/utils/supabase/auth';
import { toast } from '@/hooks/use-toast';

export const useAuthRegister = (
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const register = async (name: string, email: string, password: string): Promise<boolean> => {
    setIsLoading(true);
    try {
      const { data, error } = await supabase.auth.signUp({
        email,
        password,
        options: {
          data: {
            name: name,
          },
        },
      });

      if (error) throw error;

      if (data.user) {
        await createUserProfile(data.user.id, name);
        toast({
          title: 'Registration Successful',
          description: 'You have successfully registered.',
        });
        return true;
      }
      return false;
    } catch (error: any) {
      console.error('Registration failed:', error.message);
      toast({
        title: 'Registration Failed',
        description: error.message || 'Please try again.',
        variant: 'destructive',
      });
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { register };
};
